import type { ReadonlyDeep } from 'type-fest';

import { ResolvableFloatInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';
import type { ResolvableFloatCmp_ResolvableFloat } from '../../../components/ResolvableFields/ResolvableFloat';

export function resolvableFloatForm2ApiMapper(
  resolvableFloat: ReadonlyDeep<ResolvableFloatCmp_ResolvableFloat>,
): ReadonlyDeep<ResolvableFloatInput> {
  return pruneInput(resolvableFloat, ResolvableFloatInput);
}
